export const FETCH_VACANCY_REQUEST = 'FETCH_VACANCY_REQUEST'
export const FETCH_VACANCY_SUCCES = 'FETCH_VACANCY_SUCCES'
export const FETCH_VACANCY_ERROR = 'FETCH_VACANCY_ERROR'


// WEBPACK FOOTER //
// ./src/constants/Vacancy.js